// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2_TUQ","vLegacy":"SelectSecondary_vLegacy__3Fezm","error":"SelectSecondary_error__1I30E","disabled":"SelectSecondary_disabled__2ej-L"};